import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'undefinedAttributeFallback',
  standalone: false,
})
export class UndefinedAttributeFallbackPipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(value: string | undefined): string {
    return (
      value || this.translocoService.translate('shared.undefinedAttribute')
    );
  }
}
